let html = `<div class="time-line" data-hash="{hash}">
    <div style="width: {percent}%"></div>
</div>`

export default html